import React, { useEffect, useState } from "react";

import styles from "./styles.module.scss";

import Logo from "assets/img-winaz/redirectlanding/logo.png";
import ButtonRedirect from "assets/img-winaz/redirectlanding/btnchuyenhuong.png";
import IconDownload from "assets/img-winaz/redirectlanding/111.png";

export type RedirectInfo = {
  /** Domain the visitor is on now, e.g. "Winaz.com". */
  fromDomain: string;
  /** Domain the visitor is being sent to, e.g. "WINAZ.AC". */
  targetDomain: string;
  /** Official domain shown in the footer hint. */
  officialDomain: string;
  /** Seconds shown in the countdown before the redirect. */
  countdownSeconds: number;
};

// Placeholder values until the API supplies them.
const DEFAULT_INFO: RedirectInfo = {
  fromDomain: "Winaz.com",
  targetDomain: "WINAZ.AC",
  officialDomain: "WINAZ.AC",
  countdownSeconds: 3,
};

type RedirectLandingProps = {
  info?: Partial<RedirectInfo>;
};

const RedirectLanding: React.FC<RedirectLandingProps> = ({ info }) => {
  const { fromDomain, targetDomain, officialDomain, countdownSeconds } = {
    ...DEFAULT_INFO,
    ...info,
  };
  const [secondsLeft, setSecondsLeft] = useState(countdownSeconds);

  useEffect(() => {
    setSecondsLeft(countdownSeconds);
  }, [countdownSeconds]);

  useEffect(() => {
    if (secondsLeft <= 0) return;
    const timer = window.setTimeout(() => setSecondsLeft((s) => s - 1), 1000);
    return () => window.clearTimeout(timer);
  }, [secondsLeft]);

  return (
    <main className={styles.page}>
      <section className={styles.card}>
        <img className={styles.logo} src={Logo} alt="WinAZ" />

        <p className={styles.from}>
          <span className={styles.fromDomain}>{fromDomain}</span> đang chuyển
          hướng sang
        </p>
        <h1 className={styles.target}>{targetDomain}</h1>

        <span className={styles.spinner} aria-hidden="true" />
        <p className={styles.countdown} aria-live="polite">
          Chuyển hướng sau {Math.max(secondsLeft, 0)}s
        </p>

        <button type="button" className={styles.cta}>
          <img src={ButtonRedirect} alt="Chuyển hướng ngay" />
        </button>
      </section>

      <p className={styles.footer}>
        Cài <img className={styles.footerIcon} src={IconDownload} alt="1.1.1.1" />{" "}
        để truy cập Domain chính thức:{" "}
        <span className={styles.footerLink}>{officialDomain}</span>
      </p>
    </main>
  );
};

export default RedirectLanding;
